<template>
  <div class="main">
    <div class="graphic"></div>

    <div class="content" :class="{ dscontent: currentStep == 8 && doorStepTestTwo }">
      <div class="head-section oth" v-if="$route.query.oth === null">
        <a href="https://www.onthehouse.com.au"
          ><img class="oalogo" src="@/assets/images/oth-logo.svg"
        /></a>
        <a href="https://www.onthehouse.com.au"
          ><img class="oalogo-m" src="@/assets/images/oth-logo.svg"
        /></a>

        <div class="sidelogo">
          <span>Powered by</span>
          <a href="https://www.openagent.com.au"
            ><img
              class="oalogo"
              src="@/assets/styles/frontend-library/images/logo-openagent-green-grey.svg"
          /></a>
        </div>
      </div>

      <div class="head-section" v-if="$route.query.oth !== null">
        <a class="oalogo" href="https://www.openagent.com.au"
          ><img
            class="oalogo ga-event"
            src="@/assets/styles/frontend-library/images/logo-openagent-green-grey.svg"
            data-category="Header"
            data-eventlabel="OA Logo"
        /></a>
        <a href="https://www.openagent.com.au"
          ><img class="oalogo-m ga-event" src="@/assets/images/oa-icon-green.png"
            data-category="Header" data-eventlabel="OA Logo"
        /></a>

        <a href="tel:132434" class="headphone ga-event" data-category="Header" data-eventlabel="13 24 34">
          <svg-icon
            class="ut-mr-1"
            :icon="'icon-phone'"
            :size="15"
            :addClass="'ut-text-N10'"
            :dataCategory="'Header'"
            :dataEventlabel="'13 24 34'"      
          ></svg-icon>
          13 24 34
        </a>
      </div>

      <div
        class="formbody testimonialContainer"
        v-bind:class="{
          customFormBody: currentStep == -5,
          oth: $route.query.oth === null,
        }"
      >
        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div
            class="text1"
            v-if="
              currentStep < 6 &&
                currentStep != -15 &&
                currentStep != -14 &&
                currentStep != -17 &&
                postcodeInfo == '' &&
                this.showTitle == true
            "
          >
            Compare Agents
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div
            class="text1"
            v-if="
              currentStep < 6 &&
              currentStep != -17 &&
                currentStep != -15 &&
                currentStep != -14 &&
                postcodeInfo.agentcount > 0
            "
          >
            Compare {{ postcodeInfo.agentcount }} agents in
            {{ postcodeData.suburb }}
          </div>

          <div class="text1" v-if="currentStep == -17">
            Verify your number
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div
            class="text1"
            v-if="
              currentStep < 6 &&
                currentStep != -15 &&
                currentStep != -14 &&
                currentStep != -17 &&
                postcodeInfo.agentcount < 1
            "
          >
            Compare agents in {{ postcodeData.suburb }}
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div
            class="text1"
            v-if="currentStep > 5 && currentStep < 11 && currentStep != 10 && !phoneVerificationTestActive"
          >
            View agent shortlist
          </div>
          <div
            class="text1"
            v-if="currentStep == 8 && phoneVerificationTestActive"
          >
            We'll send you an SMS to verify
          </div>

        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div class="text1" v-if="currentStep == 10">
            Do you know we have a partner who can help you find a mortgage
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="question-header" v-if="currentStep == 1 && showIt">
            Select top performing agents for:
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == 1 && showIt" class="q-section">
            <div class="q-container lg:ut-flex">
              <div class="radio-row">
                <RadioButton
                  id="radio1"
                  v-on:input="input"
                  :name="'formData.servicetype'"
                  :gacategory="'Select top performing agents for'"
                  :gatext="'Selling'"
                  v-model="formData.servicetype"
                  :selectedValue="formData.servicetype"
                  :radioValue="'Sell a property - Seller'"
                >
                  <svg-icon
                    :icon="'icon-dollar'"
                    :size="48"
                    :addClass="''"
                  ></svg-icon>
                  <span>Selling</span>
                </RadioButton>
                <RadioButton
                  id="radio2"
                  v-on:input="input"
                  :gacategory="'Select top performing agents for'"
                  :gatext="'Selling & buying'"
                  :name="'formData.servicetype'"
                  v-model="formData.servicetype"
                  :selectedValue="formData.servicetype"
                  :radioValue="'Sell and buy a property - Seller and Buyer'"
                >
                  <svg-icon
                    :icon="'icon-replace'"
                    :size="48"
                    :addClass="''"
                  ></svg-icon>
                  <span>Selling & buying</span>
                </RadioButton>
              </div>

              <div class="radio-row">
                <RadioButton
                  id="radio3"
                  v-on:input="input"
                  :gacategory="'Select top performing agents for'"
                  :gatext="'Property management'"
                >
                  <svg-icon
                    :icon="'icon-key'"
                    :size="48"
                    :addClass="''"
                  ></svg-icon>
                  <span>Property management</span>
                </RadioButton>
                <RadioButton
                  id="radio4"
                  v-on:input="input"
                  :gacategory="'Select top performing agents for'"
                  :gatext="'Other'"
                  :name="'formData.servicetype'"
                  v-model="formData.servicetype"
                  :selectedValue="formData.servicetype"
                  :radioValue="'other'"
                >
                  <svg-icon
                    :icon="'icon-more'"
                    :size="48"
                    :addClass="''"
                  ></svg-icon>
                  <span>Other</span>
                </RadioButton>
              </div>
            </div>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="question-header" v-if="currentStep == 2 && showIt">
            What type of property are you selling?
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == 2 && showIt" class="q-section">
            <div class="q-container lg:ut-flex">
              <div class="radio-row">
                <RadioButton
                  id="radio5"
                  :gacategory="'What type of property are you selling'"
                  :gatext="'House'"
                  v-on:input="input"
                  :name="'formData.propertytype'"
                  v-model="formData.propertytype"
                  :selectedValue="formData.propertytype"
                  :radioValue="'House'"
                >
                  <svg-icon
                    :icon="'icon-house'"
                    :size="48"
                    :addClass="''"
                  ></svg-icon>
                  <span>House</span>
                </RadioButton>
                <RadioButton
                  id="radio6"
                  :gacategory="'What type of property are you selling'"
                  :gatext="'Unit'"
                  v-on:input="input"
                  :name="'formData.propertytype'"
                  v-model="formData.propertytype"
                  :selectedValue="formData.propertytype"
                  :radioValue="'Apartment'"
                >
                  <svg-icon :icon="'icon-appartment'" :size="48" :addClass="''">
                  </svg-icon>
                  <span>Unit</span>
                </RadioButton>
              </div>

              <div class="radio-row">
                <RadioButton
                  id="radio7"
                  :gacategory="'What type of property are you selling'"
                  :gatext="'Land'"
                  v-on:input="input"
                  :name="'formData.propertytype'"
                  v-model="formData.propertytype"
                  :selectedValue="formData.propertytype"
                  :radioValue="'Land'"
                >
                  <svg-icon :icon="'icon-land'" :size="48" :addClass="''">
                  </svg-icon>
                  <span>Land</span>
                </RadioButton>
                <RadioButton
                  id="radio8"
                  :gacategory="'What type of property are you selling'"
                  :gatext="'Other'"
                  v-on:input="input"
                  :name="'formData.propertytype'"
                  v-model="formData.propertytype"
                  :selectedValue="formData.propertytype"
                  :radioValue="'Other'"
                >
                  <svg-icon :icon="'icon-more'" :size="48" :addClass="''">
                  </svg-icon>
                  <span>Other</span>
                </RadioButton>
              </div>
            </div>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="question-header" v-if="currentStep == 3 && showIt">
            How many bedrooms?
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == 3 && showIt" class="q-section">
            <div class="q-container lg:ut-flex">
              <div class="radio-row">
                <RadioButton
                  id="radio9"
                  :gacategory="'How many bedrooms'"
                  :gatext="'1 Bedroom'"
                  v-on:input="input"
                  :name="'formData.be'"
                  v-model="formData.be"
                  :selectedValue="formData.be"
                  :radioValue="'1'"
                >
                  <div class="custom">
                    1
                  </div>
                  Bedroom
                </RadioButton>
                <RadioButton
                  id="radio10"
                  :gacategory="'How many bedrooms'"
                  :gatext="'2 Bedrooms'"
                  v-on:input="input"
                  :name="'formData.be'"
                  v-model="formData.be"
                  :selectedValue="formData.be"
                  :radioValue="'2'"
                >
                  <div class="custom">
                    2
                  </div>
                  Bedrooms
                </RadioButton>
              </div>

              <div class="radio-row">
                <RadioButton
                  id="radio11"
                  :gacategory="'How many bedrooms'"
                  :gatext="'3 Bedrooms'"
                  v-on:input="input"
                  :name="'formData.be'"
                  v-model="formData.be"
                  :selectedValue="formData.be"
                  :radioValue="'3'"
                >
                  <div class="custom">
                    3
                  </div>
                  Bedrooms
                </RadioButton>
                <RadioButton
                  id="radio12"
                  :gacategory="'How many bedrooms'"
                  :gatext="'4+ Bedrooms'"
                  v-on:input="input"
                  :name="'formData.be'"
                  v-model="formData.be"
                  :selectedValue="formData.be"
                  :radioValue="'4'"
                >
                  <div class="custom">
                    4+
                  </div>
                  Bedrooms
                </RadioButton>
              </div>
            </div>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="question-header" v-if="currentStep == 4 && showIt">
            How soon do you want to sell?
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == 4 && showIt" class="q-section">
            <div class="q-container lg:ut-flex">
              <div class="radio-row">
                <RadioButton
                  id="radio13"
                  :gacategory="'How soon do you want to sell'"
                  :gatext="'Now'"
                  v-on:input="input"
                  :name="'formData.expecttosell'"
                  v-model="formData.expecttosell"
                  :selectedValue="formData.expecttosell"
                  :radioValue="'Immediately'"
                >
                  <svg-icon
                    :icon="'icon-lightbolt'"
                    :size="50"
                    :addClass="''"
                  ></svg-icon>
                  <span>Now</span>
                </RadioButton>
                <RadioButton
                  id="radio14"
                  :gacategory="'How soon do you want to sell'"
                  :gatext="'3 Months'"
                  v-on:input="input"
                  :name="'formData.expecttosell'"
                  v-model="formData.expecttosell"
                  :selectedValue="formData.expecttosell"
                  :radioValue="'3 - 6 months'"
                >
                  <div class="custom">
                    3
                  </div>
                  Months
                </RadioButton>
              </div>

              <div class="radio-row">
                <RadioButton
                  id="radio15"
                  :gacategory="'How soon do you want to sell'"
                  :gatext="'6 Months'"
                  v-on:input="input"
                  :name="'formData.expecttosell'"
                  v-model="formData.expecttosell"
                  :selectedValue="formData.expecttosell"
                  :radioValue="'6 - 12 months'"
                >
                  <div class="custom">
                    6
                  </div>
                  Months
                </RadioButton>
                <RadioButton
                  id="radio16"
                  :gacategory="'How soon do you want to sell'"
                  :gatext="'12+ Months'"
                  v-on:input="input"
                  :name="'formData.expecttosell'"
                  v-model="formData.expecttosell"
                  :selectedValue="formData.expecttosell"
                  :radioValue="'I don’t know / > 12months'"
                >
                  <div class="custom">
                    12+
                  </div>
                  Months
                </RadioButton>
              </div>
            </div>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <h2
            class="question-header"
            v-if="currentStep == 5 && showIt && !askSuburb"
          >
            What is the reason for your sale?
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div
            v-if="currentStep == 5 && showIt && !askSuburb"
            class="q-section"
          >
            <div class="row">
              <div
                data-category="What is the reason for your sale"
                data-eventlabel="Relocating"
                @click="endFirstSection('Relocating')"
                class="option-field btn-s1 ga-event"
              >
                Relocating
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'What is the reason for your sale'"
                  :dataEventlabel="'Relocating'"
                ></svg-icon>
              </div>
              <div
                data-category="What is the reason for your sale"
                data-eventlabel="Investment property"
                @click="endFirstSection('Investment property')"
                class="option-field btn-s1 ga-event"
              >
                Investment property
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'What is the reason for your sale'"
                  :dataEventlabel="'Investment property'"
                ></svg-icon>
              </div>
            </div>

            <div class="row">
              <div
                data-category="What is the reason for your sale"
                data-eventlabel="Downsizing"
                @click="endFirstSection('Downsizing')"
                class="option-field btn-s1 ga-event"
              >
                Downsizing
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'What is the reason for your sale'"
                  :dataEventlabel="'Downsizing'"
                ></svg-icon>
              </div>
              <div
                data-category="What is the reason for your sale"
                data-eventlabel="Upsizing"
                @click="endFirstSection('Upsizing')"
                class="option-field btn-s1 ga-event"
              >
                Upsizing
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'What is the reason for your sale'"
                  :dataEventlabel="'Upsizing'"
                ></svg-icon>
              </div>
            </div>

            <div class="row">
              <div
                data-category="What is the reason for your sale"
                data-eventlabel="Family situation"
                @click="endFirstSection('Family situation')"
                class="option-field btn-s1 ga-event"
              >
                Family situation
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'What is the reason for your sale'"
                  :dataEventlabel="'Family situation'"
                ></svg-icon>
              </div>
              <div
                data-category="What is the reason for your sale"
                data-eventlabel="Deceased estate"
                @click="endFirstSection('Deceased estate')"
                class="option-field btn-s1 ga-event"
              >
                Deceased estate
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'What is the reason for your sale'"
                  :dataEventlabel="'Deceased estate'"
                ></svg-icon>
              </div>
            </div>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <h2
            class="question-header"
            v-if="currentStep == 5 && askSuburb && showIt"
          >
            What suburb are you selling in?
          </h2>
        </transition>

        <transition
          enter-active-class="animated Right faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == 5 && askSuburb && showIt" class="q-section">
            <SuburbSearch
              :placeholderText="'Enter your suburb or postcode'"
              class="suburbsearch suburbsearchhome suburbsearch1 ga-event"
              :gacategory="'What suburb are you selling in?'"
              :gatext="'Enter your suburb or postcode'"
              @selectedResult="getSuburb1"
              :showIcon="true"
            ></SuburbSearch>
            <div class="errormsg" v-if="suburbData == null && checkaddress">
              Please enter your suburb
            </div>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="question-header" v-if="currentStep == -22 && showIt">
            Are you considering financing to do any of the following?
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == -22 && showIt" class="q-section">
            <div class="row">
              <div
                data-category="Are you considering financing to do any of the following"
                data-eventlabel="Buying my next home"
                @click="loanCapture('Buying my next home')"
                class="option-field btn-s1 ga-event"
              >
                Buying my next home
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'Are you considering financing to do any of the following'"
                  :dataEventlabel="'Buying my next home'"
                ></svg-icon>
              </div>
              <div
                data-category="Are you considering financing to do any of the following"
                data-eventlabel="Paying for upfront selling costs"
                @click="loanCapture('Paying for upfront selling costs')"
                class="option-field btn-s1 ga-event"
              >
              Paying for upfront selling costs
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'Are you considering financing to do any of the following'"
                  :dataEventlabel="'Paying for upfront selling costs'"
                ></svg-icon>
              </div>
            </div>

            <div class="row">
              <div
                data-category="Are you considering financing to do any of the following"
                data-eventlabel="Completing repairs or renos"
                @click="loanCapture('Completing repairs or renos')"
                class="option-field btn-s1 ga-event"
              >
                Completing repairs or renos
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'Are you considering financing to do any of the following'"
                  :dataEventlabel="'Completing repairs or renos'"
                ></svg-icon>
              </div>
              <div
                data-category="Are you considering financing to do any of the following"
                data-eventlabel="Refinancing current debt"
                @click="loanCapture('Refinancing current debt')"
                class="option-field btn-s1 ga-event"
              >
                Refinancing current debt
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'Are you considering financing to do any of the following'"
                  :dataEventlabel="'Refinancing current debt'"
                ></svg-icon>
              </div>
            </div>

            <div class="row">
              <div
                data-category="Are you considering financing to do any of the following"
                data-eventlabel="Nothing at this time"
                @click="loanCapture('Nothing at this time')"
                class="option-field btn-s1 ga-event"
              >
                Nothing at this time
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'Are you considering financing to do any of the following'"
                  :dataEventlabel="'Nothing at this time'"
                ></svg-icon>
              </div>
              <div class="option-field empty-btn"></div>
            </div>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="question-header" v-if="currentStep == -10 && showIt">
            So, how could they help?
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == -10 && showIt" class="q-section">
            <div class="row">
              <div
                @click="otherSection('Property Appraisal')"
                data-category="So how could they help"
                data-eventlabel="Property Appraisal"
                class="option-field btn-s1 ga-event"
              >
                Property Appraisal
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'So how could they help'"
                  :dataEventlabel="'Property Appraisal'"
                ></svg-icon>
              </div>
              <div
                @click="otherSection('Im an Agent')"
                data-category="So how could they help"
                data-eventlabel="Im an agent"
                class="option-field btn-s1 ga-event"
              >
                I'm an Agent
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'So how could they help'"
                  :dataEventlabel="'Im an agent'"
                ></svg-icon>
              </div>
            </div>

            <div class="row">
              <div
                @click="otherSection('Property Manager')"
                data-category="So how could they help"
                data-eventlabel="Property Manager"
                class="option-field btn-s1 ga-event"
              >
                Property Manager
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'So how could they help'"
                  :dataEventlabel="'Property Manager'"
                ></svg-icon>
              </div>
              <div
                @click="otherSection('General Enquiry')"
                data-category="So how could they help"
                data-eventlabel="General Enquiry"
                class="option-field btn-s1 ga-event"
              >
                General Enquiry
                <svg-icon
                  :icon="'icon-arrow-foward'"
                  :size="19"
                  :addClass="''"
                  :dataCategory="'So how could they help'"
                  :dataEventlabel="'General Enquiry'"
                ></svg-icon>
              </div>
            </div>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="question-header" v-if="currentStep == -5 && showIt">
            What type of rental agent are you looking for?
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == -5 && showIt" class="q-section">
            <div
              @click="otherSection('Property manager2')"
              class="ut-mb-4 option-field btn-s1 ga-event"
              data-category="What type of rental agent are you looking for"
              data-eventlabel="A property manager to rent my property"
            >
              A property manager to rent my property
              <svg-icon
                :icon="'icon-arrow-foward'"
                :size="19"
                :addClass="''"
                :dataCategory="'What type of rental agent are you looking for'"
                :dataEventlabel="'A property manager to rent my property'"
              ></svg-icon>
            </div>
            <div
              @click="otherSection('Agent rent')"
              class="option-field btn-s1 ga-event"
              data-category="What type of rental agent are you looking for"
              data-eventlabel="An agent to find me a property to rent"
            >
              An agent to find me a property to rent
              <svg-icon
                :icon="'icon-arrow-foward'"
                :size="19"
                :addClass="''"
                :dataCategory="'What type of rental agent are you looking for'"
                :dataEventlabel="'An agent to find me a property to rent'"
              ></svg-icon>
            </div>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="form-header" v-if="currentStep == 6 && showIt">
            What email address should we send your top agent shortlist to?
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == 6 && showIt" class="q-section">
            <div class="ut-my-6 inputbox">
              <input
                class="oa-text-input ga-event"
                data-category="What email address"
                data-eventlabel="Email address"
                ref="email"
                name="email"
                type="email"
                v-model="formData.email"
                placeholder="Email address"
                @focus="emailFocus()"
                @keyup.enter="input()"
              />
              <div class="errormsg" v-if="!validemail">
                Please enter a valid email
              </div>
            </div>

            <div
              @click="input()"
              class="ut-mb-4 btn ga-event"
              data-category="What email address"
              data-eventlabel="Next step"
            >
              Next step
              <svg-icon
                :icon="'icon-arrow-foward'"
                :size="19"
                :addClass="''"
                :dataCategory="'What email address'"
                :dataEventlabel="'Next step'"
              ></svg-icon>
            </div>
            <testimonial :step="currentStep" :isShown="true" class="testimonial-email"></testimonial>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="form-header" v-if="currentStep == 7 && showIt">
            Thank you, what name should we send it to?
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == 7 && showIt" class="q-section">
            <div class="ut-my-6 inputbox">
              <input
                class="oa-text-input ga-event"
                data-category="What first name"
                data-eventlabel="Please enter your First name"
                ref="name"
                name="name"
                type="text"
                v-model="formData.name"
                placeholder="First Name"
                @focus="nameFocus()"
                @keyup.enter="input()"
              />

              <input
                class="oa-text-input ga-event ut-mt-4"
                data-category="What last name"
                data-eventlabel="Please enter your last name "
                ref="lname"
                name="lname"
                type="text"
                v-model="formData.lname"
                placeholder="Last name"
                @focus="nameFocus()"
                @keyup.enter="input()"
              />
              <div class="errormsg" v-if="(formData.lname == '' || formData.name == '') && checkname">
                Please enter your first name and last name
              </div>
            </div>

            <div
              @click="input()"
              class="ut-mb-4 btn ga-event"
              data-category="What name"
              data-eventlabel="Next step"
            >
              Next step
              <svg-icon
                :icon="'icon-arrow-foward'"
                :size="19"
                :addClass="''"
                :dataCategory="'What name'"
                :dataEventlabel="'Next step'"
              ></svg-icon>
            </div>
            <testimonial :step="currentStep" :isShown="true" class="testimonial-name"></testimonial>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="form-header" v-if="currentStep == 8 && showIt">
            Finally {{ firstName }}, what's the best number to contact you on if
            we find new information on agents in your shortlist?
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == 8 && showIt" class="q-section">
            <!-- <div class="ut-break-normal"> -->
            <div class="ut-my-6 inputbox">
              <input
                inputMode="tel"
                class="oa-text-input ga-event"
                ref="phone"
                name="phone"
                type="text"
                data-category="What phone number"
                data-eventlabel="Contact number"
                v-model="formData.phone"
                placeholder="Contact number"
                @focus="phoneFocus()"
                @keyup.enter="input()"
              />
              <div class="errormsg" v-if="!validphone">
                Please enter a valid phone number
              </div>
            </div>

            <div v-if="doorStepTestTwo" class="mid-text ">
              <p>
                Would you also like to speak to Doorsteps <br />
                Finance about mortgage selection
              </p>
              <p class="ut-text-N10 ut-ml-2">
                <checkbox
                  :gacategory="'Would you also like to speak to Doorsteps'"
                  :gatext="'Click Checkbox'"
                  v-model="agreeToDoorStepFinance"
                  :value="false"
                >
                  <span
                    class="ut-text-N10 ut-align-bottom"
                    style="margin-left: -8px;"
                  >
                    Yes
                  </span>
                </checkbox>
              </p>
              <span class="ut-text-xs">
                If you select yes your information will be shared with Doorsteps
                Finance so they can assist
              </span>
            </div>

            <div
              @click="input()"
              class="ut-mb-4 btn ga-event"
              data-category="What phone number"
              data-eventlabel="Receive my agent shortlist"
            >
              Receive my agent shortlist
              <svg-icon
                :icon="'icon-arrow-foward'"
                :size="19"
                :addClass="''"
                :dataCategory="'What phone number'"
                :dataEventlabel="'Receive my agent shortlist'"
              ></svg-icon>
            </div>
            <testimonial :step="currentStep" :isShown="true" class="testimonial-phone"></testimonial>
            <div class="review-block">
              <div class="stars">
                <svg-icon
                  :icon="'icon-star'"
                  :size="23"
                  :addClass="'ut-text-Gnew'"
                ></svg-icon>
                <svg-icon
                  :icon="'icon-star'"
                  :size="23"
                  :addClass="'ut-text-Gnew'"
                ></svg-icon>
                <svg-icon
                  :icon="'icon-star'"
                  :size="23"
                  :addClass="'ut-text-Gnew'"
                ></svg-icon>
                <svg-icon
                  :icon="'icon-star'"
                  :size="23"
                  :addClass="'ut-text-Gnew'"
                ></svg-icon>
                <svg-icon
                  :icon="'icon-star'"
                  :size="23"
                  :addClass="'ut-text-N1'"
                ></svg-icon>
              </div>
              <p class="reviewtext">
                Great advice, informative, friendly and efficient.
              </p>
              <p class="reviewname">Tania Fragopoulos</p>
            </div>

            <!-- </div> -->
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="form-header" v-if="currentStep == -17 && showIt">
            Enter your 4 digit code to see your agent shortlist
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == -17 && showIt" class="q-section ">
          
            <div class="ut-my-6 otp-box ut-w-48 ut-ml-0">

              <otp-input
                :isValid="isCodeValid"
                activeInputClass="active-input-class"
                separateWrapperClass="otp-wrapper"
                separateInputClass=" ut-mr-2 ut-text-lg ut-border ut-rounded ut-py-2 ut-px-4 ut-w-12 ut-border-Gnew focus:ut-outline-none focus:ut-border-2 ut-h-12"
                :digits="4"
                :placeholder="null"
                :autoFocus="true"
                @on-complete="handleOPTOnComplete"
                @on-changed="handleOPTOnChange"
                @on-paste="onPasteHandler">
                  <template #errorMessage> Invalid code </template>
              </otp-input>

            </div>

          

            <div
              @click="validateOTP"
              class="ut-mb-4 btn ga-event"
              data-category="4 digit code"
              data-eventlabel="Continue"
            >
              Continue
              <svg-icon
                :icon="'icon-arrow-foward'"
                :size="19"
                :addClass="''"
                :dataCategory="'4 digit code'"
                :dataEventlabel="'Continue'"
              ></svg-icon>
            </div>
            <div v-if="otpError" class="ut-mt-1 ut-text-sm ut-text-red400 ut-capitalize">Invalid code</div>
            <span class="ut-text-N10 ut-align-middle">
              The code was sent to {{ formData.phone }}. If this number is incorrect, 
              <a @click="backClick()" data-category="4 digit code" data-eventlabel="change number" class="ut-underline">change number</a>
            </span>
            
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="form-header" v-if="currentStep == 9 && showIt">
            Enter the address of the property your are looking to sell
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == 9 && showIt" class="q-section">
            <AddressSearch
              :disabled="disableAddressInput"
              :placeholderText="'Enter your property address'"
              :dataCategory="'Enter the address of the property'"
              :dataEventLabel="'Enter your property address'"
              class="addressSearchBox ga-event"
              @selectedResult="getAddress"
              :showIcon="true"
            ></AddressSearch>
            <div
              class="errormsg"
              v-if="address == null && checkaddress && !noAddress"
            >
              Please enter your property address
            </div>

            <p class="ut-text-N10 ut-my-6">
              <checkbox
                :gacategory="'Enter the address of the property'"
                :gatext="'I cant find my address in the list'"
                v-model="noAddress"
                :value="false"
              >
                <span class="ut-text-N10 ut-align-middle"
                  >I can't find my address in the list</span
                >
              </checkbox>
            </p>

            <div v-if="noAddress">
              <div class="ut-my-4 inputbox">
                <input
                  class="oa-text-input ga-event"
                  name="manualStreetAddress"
                  type="text"
                  v-model="manualStreetAddress"
                  placeholder="Enter your street address"
                  data-category="Enter the address of the property"
                  data-eventlabel="Enter your street address"
                />
                <div
                  class="errormsg"
                  v-if="manualStreetAddress == '' && checkaddress"
                >
                  Please enter your street
                </div>
              </div>

              <div class="ut-mb-4 inputbox">
                <SuburbSearch
                  :placeholderText="'Enter your suburb or postcode'"
                  class="suburbsearch suburbsearchhome"
                  :gacategory="'Enter the address of the property'"
                  :gatext="'Enter your suburb or postcode'"
                  @selectedResult="getSuburb"
                  :showIcon="true"
                ></SuburbSearch>
                <div class="errormsg" v-if="suburbData == null && checkaddress">
                  Please enter your suburb
                </div>
              </div>
            </div>

            <div class="ut-my-6">
              <h2 class="form-header3">
                I own or can act on behalf of the owner of this property.
              </h2>

              <span class="ut-text-N10 ut-py-6">
                <checkbox
                  :gacategory="'I own or can act on behalf of the owner of this property.'"
                  :gatext="'Yes'"
                  :inLine="true"
                  v-model="isOwner"
                  :value="true"
                  @change="isOwnerYesUpdated"
                >
                  <span class="ut-text-N10 ut-align-middle"
                    >Yes</span
                  >
                </checkbox>

                <checkbox
                  :gacategory="'I own or can act on behalf of the owner of this property.'"
                  :gatext="'No'"
                  :inLine="true"
                  v-model="isNotOwner"
                  :value="true"
                  @change="isOwnerNoUpdated"
                >
                  <span class="ut-text-N10 ut-align-middle"
                    >No</span
                  >
                </checkbox>
                <p class="errormsg ut-mb-4" v-if="!isOwner && !isNotOwner && isHomeOwnerError">
                  Please select home owner status
                </p>
              </span>
              
            </div>

            <div
              @click="input()"
              class="ut-mb-4 btn ga-event"
              data-category="Enter the address of the property"
              data-eventlabel="View shortlist now"
            >
              View shortlist now
              <svg-icon
                :icon="'icon-arrow-foward'"
                :size="19"
                :addClass="''"
                :dataCategory="'Enter the address of the property'"
                :dataEventlabel="'View shortlist now'"
              ></svg-icon>
            </div>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <h2
            class="form-header-fullwidth"
            v-if="currentStep == 10 && showIt && doorStepTestOne"
          >
            Would you like to speak to Doorsteps Finance about mortgage
            selection
          </h2>
        </transition>
        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <div
            v-if="currentStep == 10 && showIt && doorStepTestOne"
            class="q-section"
          >
            <p class="ut-text-N10 ut-my-6">
              <span class="ut-text-N10 ut-align-middle">
                If you select yes your information will be shared with Doorsteps
                Finance so they can assist
              </span>
            </p>

            <div class="row">
              <div
                data-category="Information will be shared with doorsteps"
                data-eventlabel="Yes"
                @click="doorStepFinanceCreateLeadAndRedirect(true)"
                class="option-field btn-s1 ga-event"
              >
                Yes
              </div>
              <div
                data-category="Information will be shared with doorsteps"
                data-eventlabel="No"
                @click="doorStepFinanceCreateLeadAndRedirect(false)"
                class="option-field btn-s1 ga-event"
              >
                No
              </div>
            </div>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <LoadingSpinner v-if="showLoadingSpinner"></LoadingSpinner>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="form-header2" v-if="currentStep == -15 && showIt">
            Leave your details and we'll be in touch
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == -15 && showIt" class="q-section">
            <div class="ut-my-4 inputbox">
              <input
                class="oa-text-input ga-event"
                name="name"
                type="text"
                v-model="formData.name"
                placeholder="Name"
                data-category="Leave your details"
                data-eventlabel="Name"
              />
              <div class="errormsg" v-if="formData.name == '' && sendmessage">
                Please enter your name
              </div>
            </div>

            <div class="ut-my-4 inputbox">
              <input
                class="oa-text-input ga-event"
                name="email"
                type="email"
                v-model="formData.email"
                placeholder="Email"
                data-category="Leave your details"
                data-eventlabel="Email"
              />
              <div class="errormsg" v-if="!validemail">
                Please enter a valid email
              </div>
            </div>

            <div class="ut-my-4 inputbox">
              <input
                class="oa-text-input ga-event"
                name="phone"
                type="text"
                v-model="formData.phone"
                placeholder="Contact number"
                data-category="Leave your details"
                data-eventlabel="Contact number"
              />
              <div class="errormsg" v-if="!validphone">
                Please enter a valid phone number
              </div>
            </div>

            <div class="ut-my-4 inputbox">
              <textarea
                class="oa-textarea ga-event"
                v-model="message"
                placeholder="Message"
                data-category="Leave your details"
                data-eventlabel="Message"
              ></textarea>
              <div class="errormsg" v-if="message == '' && sendmessage">
                Please enter your message
              </div>
            </div>

            <div @click="input()" class="ut-mb-4 btn ga-event" data-category="Leave your details">
              Send message
              <svg-icon
                :icon="'icon-arrow-foward'"
                :size="19"
                :addClass="''"
                :dataCategory="'Leave your details'"
                :dataEventlabel="'Send message'"
              ></svg-icon>
            </div>
          </div>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <h2 class="form-header" v-if="currentStep == -14 && showIt">
            Thank your for your enquiry
          </h2>
        </transition>

        <transition
          enter-active-class="animated fadeInRight faster"
          leave-active-class="animated fadeOutLeft faster"
          mode="out-in"
          :duration="500"
        >
          <div v-if="currentStep == -14 && showIt" class="q-section">
            <p>We will be in touch shortly.</p>
          </div>
        </transition>
      </div>

      <div class="foottext">
        <div
          v-if="currentStep !== 1 && currentStep !== 9"
          class="back-btn ga-event"
          :class="{ oth: $route.query.oth === null }"
          @click="backClick()"
          data-category="Smartsearch"
          data-eventlabel="Back"
        >
          <svg-icon
            v-if="$route.query.oth !== null"
            :icon="'icon-arrow-back'"
            :size="19"
            :addClass="'ut-text-Gnew'"
            :dataCategory="'Smartsearch'"
            :dataEventlabel="'Back'"
          ></svg-icon>
          <svg-icon
            v-if="$route.query.oth === null"
            :icon="'icon-arrow-back'"
            :size="19"
            :addClass="'ut-text-blueOTH'"
            :dataCategory="'Smartsearch'"
            :dataEventlabel="'Back'"
          ></svg-icon>
        </div>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <p class="smalltxt" v-if="currentStep == -15 && showIt">
            Your information will not be shared without your explicit
            permission. By submitting you agree to the
            <a
              href="https://www.openagent.com.au/terms"
              class="ga-event"
              data-category="Leave your details"
              data-eventlabel="Terms and conditions"
              target="_blank"
              >Terms and conditions.</a
            >
          </p>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <p class="smalltxt" v-if="currentStep == 6 && showIt">
            Your email address is safe with us and will not be shared with
            agents.
            <a
              href="https://www.openagent.com.au/terms"
              class="ga-event"
              data-category="What email address"
              data-eventlabel="Terms and conditions"
              target="_blank"
              >Terms and conditions.</a
            >
          </p>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <p class="smalltxt" v-if="currentStep == 8 && showIt">
            Your number will not be shared with agents without your consent, and
            will only be used by our team to gather more information. By
            submitting this information, you agree to our
            <a
              href="https://www.openagent.com.au/terms"
              target="_blank"
              class="ga-event"
              data-category="What phone number"
              data-eventlabel="User terms"
              >User Terms</a
            >
            and
            <a
              href="https://www.openagent.com.au/privacy-policy"
              target="_blank"
              class="ga-event"
              data-category="What phone number"
              data-eventlabel="Privacy policy"
              >Privacy Policy</a
            >.
          </p>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <p class="smalltxt" v-if="currentStep == 9 && showIt">
            We will use your address to find the agent who sold similar
            properties closest to yours.
          </p>
        </transition>

        <transition
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
          mode="out-in"
          :duration="500"
        >
          <p
            class="smalltxt ut-mt-2"
            v-if="
              (currentStep == 10 && showIt && doorStepTestOne) ||
                (currentStep == 8 && showIt && doorStepTestTwo)
            "
          >
            Doorsteps Finance Pty Ltd (Doorsteps Finance) is a division of
            OpenAgent. Doorsteps Finance Pty Ltd (Doorsteps Finance) Ltd is
            authorised as a credit representative under Australian Credit
            Licence 389087. By pressing yes you agree to their
            <a href="https://www.doorsteps.com.au/terms" target="_blank"
              >User Terms</a
            >
            and
            <a
              href="https://www.doorsteps.com.au/finance-privacy-policy/"
              target="_blank"
              >Privacy Policy</a
            >
          </p>
        </transition>
      </div>

      <ProgressBar v-if="showProgress" :setbarwidth="progress"></ProgressBar>
      <!-- <ProgressBar v-if="currentStep < 0" :setbarwidth="100"></ProgressBar> -->
    </div>

    <transition
      enter-active-class="animated fadeIn faster"
      leave-active-class="animated fadeOut faster"
      mode="out-in"
      :duration="500"
    >
      <AgentLoader
        :agents="agents"
        :postcodeData="postcodeData"
        v-if="showAgentLoader"
      ></AgentLoader>
    </transition>
  </div>
</template>

<script>

import axios from "axios";
import RadioButton from "@/components/forms/RadioButton.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import AgentLoader from "@/components/AgentLoader.vue";
import AddressSearch from "@/components/forms/search/AddressSearch.vue";
import SuburbSearch from "@/components/forms/search/SuburbSearch.vue";
import qs from "qs";
import indigoHelpers from "../helpers/indigo-helpers";
import Checkbox from "@/components/forms/Checkbox.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import validationHelpers from "../helpers/validation-helpers";
import {virtualPageView, createEvent} from '@oa-shared-components/oa-fe-ga-library';
import OtpInput from 'otp-input-vue2';
import Testimonial from "@/components/Testimonial.vue";

export default {
  name: "Home",
  components: {
    RadioButton,
    ProgressBar,
    SvgIcon,
    AgentLoader,
    AddressSearch,
    Checkbox,
    SuburbSearch,
    LoadingSpinner,
    OtpInput,
    Testimonial,
  },
  data() {
    return {
      isCodeValid: true,
      otpComplete: false,
      otpError: false,
      otpCode: null,
      otpValidating: false,
      currentStep: 1,
      showIt: false,
      postcodeData: "",
      postcodeInfo: "",
      showAgentLoader: false,
      agents: null,
      checkemail: false,
      checkphone: false,
      checkname: false,
      disableAddressInput: false,
      address: null,
      interactionKey: null,
      leadKey: null,
      showTitle: false,
      manualStreetAddress: "",
      noAddress: false,
      isOwner: false,
      isNotOwner: false,
      isHomeOwnerError: false,
      checkaddress: false,
      suburbData: null,
      message: "",
      askSuburb: false,
      sendmessage: false,
      agreeToDoorStepFinance: false,
      lead: null,
      interaction: null,
      formData: {
        servicetype: null,
        propertytype: true,
        be: "",
        name: "",
        lname: "",
        phone: "",
        email: "",
        postcodeid: this.$route.query.pid,
        brand: "OpenAgent",
        call: 1,
        dialleractiontypeid: 2,
        ch: 59,
        st: "",
        po: "",
        su: "",
        latitude: null,
        longitude: null,
        additionalInfo: "",
        expecttosell: null,
        clientUserAgent: navigator.userAgent,
      },
      addressFormData: {
        rpdataid: null, 
        streetaddress: null,
        suburb: null,
        state: null,
        postcode: null,
        postcodeid: null,
        latitude: null,
        longitude: null,
        propertyowner: null,
      },
    };
  },
  computed: {
    showLoadingSpinner() {
      if (this.doorStepTestOne) {
        return this.currentStep == 11 && this.showIt;
      }

      return this.currentStep == 10 && this.showIt;
    },
    doorStepTestOne() {
      return this.$route.query.dst == "v1";
    },
    doorStepTestTwo() {
      return this.$route.query.dst == "v2";
    },
    phoneVerificationTestActive() {

      // keeping this to make test in prod easy, if query param has pv = 1 phone verificaton will be turned off -->
      return this.$route.query.pv !== "2";
    },
    removeQuestionsTestActive() {
      return this.$route.query.rq == "1";
    },
    skipAddressQuestionsTestActive() {
      return this.$route.query.saq == "1";
    },
    showProgress() {
      return (
        (this.currentStep > 0 && this.currentStep < 6) ||
        this.currentStep == -22
      );
    },
    progress() {
      let v = 6;
      let toDivide = this.currentStep;
      if (this.currentStep == -22) toDivide = 6;
      return (toDivide / v) * 100;
    },
    validemail() {
      if (this.checkemail || this.sendmessage) {
        return validationHelpers.emailValidation(this.formData.email);
      }
      return true;
    },
    validphone() {
      if (this.checkphone || this.sendmessage) {
        return validationHelpers.phoneValidation(this.formData.phone);
      }
      return true;
    },
    streetaddress() {
      if (this.address !== null) {
        return this.address.address;
      }
      return "";
    },
    firstName() {
      return this.formData.name.replace(/ .*/, "");
    },
  },
  methods: {
    async createLead() {
      this.formData.dialleractiontypeid = 2;

      this.formData.phonenumberverifieddate = (this.otpComplete) ? validationHelpers.getCurrentDateTime() : null;

        this.formData.additionalInfo = `Property Type - ${
          this.formData.propertytype
        }\n${
          this.formData.be != "null"
            ? `Number of Bedrooms - ${this.formData.be}\n` +
              `Expect to sell - ${this.formData.expecttosell}\n` +
              `Reason for sale - ${this.formData.reasonforsale}\n`
            : ""
        }`;

      this.formData.name = this.formData.name.trim() + ' ' + this.formData.lname.trim();
      return indigoHelpers
      .createLeadForInteraction(this.formData, this.interactionKey)
      .then(async (res) => {        
        this.leadKey = res.key;
        this.lead = res;
        
        if (this.doorStepTestTwo) {
          if (this.agreeToDoorStepFinance) {
            //create doorstep lead here
            await this.createDoorStepLead(this.formData);
          }
          
          //store answer here
          await this.saveDSAnswer(this.agreeToDoorStepFinance);
        }
        /**
         * SAQ A/B TEST:
         * return leadkey so we can redirect to DIY after phone verification
         *  */          
        return res.key;
      })
      .catch((error) => {
        console.log(error);
        return null;
      });
    },
    handleOPTOnChange(lastEnteredCode){
      console.log("code changed",  lastEnteredCode);
    },
    onPasteHandler(code){
		  console.log("code pasted",  code);
		},
    handleOPTOnComplete(value) {
      this.otpCode = value;
      console.log('OTP completed: ', value);
    },
    async validateOTP() {
      this.otpError = false;

      if(!this.otpCode){
        this.otpError = true;
        return;
      }

      if(this.otpCode && !this.otpValidating ) {
        //start validating
        this.otpValidating = true;
        //call api
        
        let validateURL = `${process.env.VUE_APP_OA_URL}/api/phone/verify.php`;
          
          let phoneToPost = validationHelpers.getPhoneForValidation(this.formData.phone);
          const formData = new FormData();
          formData.append('phone', phoneToPost);
          formData.append('otp', this.otpCode);

          try{

            await axios.post(validateURL, formData).then(res => {
              let response = res.data;
              console.log(response)
              if(response.success){
                this.otpComplete = true;
                this.input(null);
              }else{
                this.otpComplete = false;
                this.otpError = true;
                this.otpValidating = false;
              }
            })

          }catch(e){
              this.otpComplete = false;
              this.otpError = true;
              this.otpValidating = false;
          }
          
        
      }

    },
    async saveDSAnswer(createLead) {
      let ans = createLead ? "Yes" : "No";

      oa.api.customerQA
        .createQAResponse(
          null,
          null,
          98,
          ans,
          this.interaction.id,
          this.lead.id
        )
        .then(function(result) {
          console.log(result);
        });
    },

    async doorStepFinanceCreateLeadAndRedirect(createLead) {
      if (createLead) {
        //if create lead create lead
        await this.createDoorStepLead(this.formData);
      }

      //store answer here
      await this.saveDSAnswer(createLead);
      // DIY V2 PRE PROD TEST
      window.location = `${process.env.VUE_APP_OA_URL}/diy/v2/${this.leadKey}`;
      setTimeout(() => {
        this.showIt = false;
        this.currentStep++;
      }, 0);

      setTimeout(() => {
        this.showIt = true;
        switch (this.currentStep) {
          case 6:
            this.$nextTick(() => this.$refs.email.focus());
            break;
          case 7:
            this.$nextTick(() => this.$refs.name.focus());
            break;
          case 8:
            this.$nextTick(() => this.$refs.phone.focus());
            break;
          default:
            break;
        }
      }, 600);
    },
    async createDoorStepLead(data) {
      try {
        const currentProperty = {
            suburb: this.formData.su,
            state: this.formData.st,
            postCode: this.formData.po,
          };
        let doorStepContactKey = await this.getDoorStepContactKey(data, currentProperty);
        console.log(data);
        //create doorstep lead
        let leadData = {
          comment: data.consideringloan,
          externalId: this.leadKey,
          leadTypeId: 2,
          sourceTypeId: process.env.VUE_APP_DOORSTEP_SOURCE_TYPE_ID,
          referrerTypeId: process.env.VUE_APP_DOORSTEP_REFERRER_TYPE_ID,
        };
        await axios
          .post(
            `${process.env.VUE_APP_DOORSTEP_FINANCE_API_URL}/contacts/${doorStepContactKey}/leads`,
            leadData
          )
          .then((response) => {
            return response;
          });
      } catch (e) {
        console.log(e);
      }
    },

    getDoorStepContactKey: async (data, currentProperty) => {
      return new Promise((resolve) => {
        let email = encodeURIComponent(data.email);
        axios
          .get(
            `${process.env.VUE_APP_DOORSTEP_FINANCE_API_URL}/contacts?email=${email}`
          )
          .then((response) => {
            resolve(response.data.data[0].key);
          })
          .catch(async(e) => {
            let propertyId = null;
            try{
              propertyId = await axios.post(`${process.env.VUE_APP_DOORSTEP_FINANCE_API_URL}/propertyAddress`, currentProperty).then(response => {
              return response.data.data.id;
              });  
            }catch(e){}
            //contact doesnot exist
            //create new contact
            let contactData = {
              propertyId,
              fullName: data.name,
              email: data.email,
              phone: data.phone,
              sourceTypeId: process.env.VUE_APP_DOORSTEP_SOURCE_TYPE_ID,
              referrerTypeId: process.env.VUE_APP_DOORSTEP_SOURCE_TYPE_ID,
            };
            axios
              .post(
                `${process.env.VUE_APP_DOORSTEP_FINANCE_API_URL}/contacts`,
                contactData
              )
              .then((response) => {
                resolve(response.data.data.key);
              });
          });
      });
    },

    isOwnerYesUpdated(event) {
      this.isOwner = event;
      this.isNotOwner = !event;
    },

    isOwnerNoUpdated(event) {
      this.isNotOwner = event;
      this.isOwner = !event;
    },

    getSuburb(selected) {
      this.suburbData = selected;
      this.setGeoGADataLayerVars(
        this.suburbData.suburb,
        this.suburbData.state,
        this.suburbData.postcode,
        this.suburbData.postcodeId
      );
    },
    getSuburb1(selected) {
      const queries = JSON.parse(JSON.stringify(this.$route.query));
      this.suburbData = selected;
      this.askSuburb = false;

      virtualPageView("/smartsearch/loan");

      this.showIt = false;
      this.currentStep = -22;

      setTimeout(() => {
        this.showIt = true;
      }, 600);

      axios
        .get(
          `${process.env.VUE_APP_API_URL}/postcoderest/${this.suburbData.id}`
        )
        .then((response) => {
          this.postcodeData = response.data.data;
          this.formData.st = this.postcodeData.state;
          this.formData.su = this.postcodeData.suburb;
          this.formData.po = this.postcodeData.postcode;
          this.formData.postcodeid = this.postcodeData.id;
          this.formData.latitude = this.postcodeData.latitude;
          this.formData.longitude = this.postcodeData.longitude;


          this.setGeoGADataLayerVars(
            this.postcodeData.suburb,
            this.postcodeData.state,
            this.postcodeData.postcode,
            this.postcodeData.id
          );
        })
        .catch((e) => {
          console.log(e);
        });

      axios
        .get(
          `${process.env.VUE_APP_API_URL}/postcoderest/info/${this.suburbData.id}`
        )
        .then((response) => {
          this.postcodeInfo = response.data.data;
        })
        .catch((e) => {
          console.log(e);
        });

      queries.pid = this.suburbData.id;

      this.$router.push({
        query: queries,
      });
    },
    loanCapture(value) {
      this.formData.consideringloan = value;

      virtualPageView("/smartsearch/email");
      this.showIt = false;
      this.currentStep = 6;
      this.showAgentLoader = true;

      setTimeout(() => {
        this.showAgentLoader = false;
        this.showIt = true;
        this.$nextTick(() => this.$refs.email.focus());
      }, 5500);
    },
    getAddress(selected) {
      this.address = selected;

      (this.addressFormData.rpdataid = this.address.id),
        (this.addressFormData.streetaddress = this.address.details.streetaddress),
        (this.addressFormData.suburb = this.address.details.suburb),
        (this.addressFormData.state = this.address.details.state),
        (this.addressFormData.postcode = this.address.details.postcode),
        (this.addressFormData.latitude = this.address.details.latitude),
        (this.addressFormData.longitude = this.address.details.longitude);
        
        if(this.removeQuestionsTestActive) {
          this.addressFormData.propertytype = this.address.details.propertytype;
        }

        axios
          .get(
            `${process.env.VUE_APP_API_URL}/postcoderest/find/${selected.details.suburb}`
          )
          .then((res) => {
            this.formData.postcodeid = res.data.data[0].id;
            this.addressFormData.postcodeid = res.data.data[0].id;

            for (let i = 0; i < res.data.data.length; i++) {
              if (
                res.data.data[i].suburb == this.addressFormData.suburb &&
                res.data.data[i].postcode == this.addressFormData.postcode &&
                res.data.data[i].state == this.addressFormData.state
              ) {
                this.formData.postcodeid = res.data.data[i].id;
                this.addressFormData.postcodeid = res.data.data[i].id;
              }
            }
          })
          .catch((e) => {
            console.log(e);
          });
    },
    emailFocus() {
    },
    nameFocus() {
    },
    phoneFocus() {
    },
    async input(value){
      const queries = JSON.parse(JSON.stringify(this.$route.query));

      const udpateInteractionURL = `${process.env.VUE_APP_API_URL}/InteractionREST/${this.interactionKey}`;
      const udpateInteractionData = new FormData();

      if (this.currentStep == 1) {
        virtualPageView("/smartsearch/type");
        this.$helpers.gaSetVariable({ serviceType: value });

        if (value == "Sell a property - Seller") {
          queries.st = 1;
          this.$router.push({
            query: queries,
          });
        } else if (value == "Sell and buy a property - Seller and Buyer") {
          queries.st = 2;
          this.$router.push({
            query: queries,
          });
        } else if (value == "other") {
          queries.st = 5;
          this.$router.push({
            query: queries,
          });
          this.currentStep = -11;
        } else {
          queries.st = 4;
          this.$router.push({
            query: queries,
          });
          this.currentStep = -6;
        }
      } else if (this.currentStep == 2) {
        if (value == "Land") {
          this.showIt = false;
          this.currentStep = 3;
        }

        virtualPageView("/smartsearch/beds");
        this.formData.propertytype = value;
        this.$helpers.gaSetVariable({
          propertyType: this.formData.propertytype,
        });
      } else if (this.currentStep == 3) {
        virtualPageView("/smartsearch/expecttosell");
        this.formData.be = value;
        this.$helpers.gaSetVariable({ bedrooms: this.formData.be });
      } else if (this.currentStep == 4) {
        virtualPageView("/smartsearch/reasonforsale");

        if (value == "12+") {
          this.formData.expecttosell = "I don’t know / > 12months";
        }

        this.$helpers.gaSetVariable({ sellingTimeframe: value });

        axios
          .get(
            `${process.env.VUE_APP_API_URL}/SeoREST/geo-suburb-page?postcode=${this.postcodeData.postcode}&suburb=${this.postcodeData.suburbslug}&state=${this.postcodeData.state}&sort=recent&page=1&limit=15`
          )
          .then((response) => {
            console.log(response);
            this.agents = response.data.data.agents;
          })
          .catch((e) => {
            console.log(e);
          });
      } else if (this.currentStep == 6) {
        this.checkemail = true;

        if (!this.validemail) {
          return;
        }
        indigoHelpers
          .createInteraction(this.formData)
          .then((res) => {
            //send vero event for mortgate interest here
            _veroq.push([
              "track",
              "mortgage.interest",
              {
                event_property_one: this.formData.consideringloan,
              },
            ]);

            this.interactionKey = res.key;
            this.interaction = res;
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (this.currentStep == 7) {
        this.checkname = true;

        if (this.formData.name == "") {
          return;
        }

        if(this.formData.lname == "") {
          return;
        }

        //udpate interaction name
        udpateInteractionData.append('name', this.formData.name.trim() + ' '+this.formData.lname.trim());
        axios.put(udpateInteractionURL, udpateInteractionData).then(res => {
          console.log(res.data)
        });

      } else if (this.currentStep == 8) {
        this.checkphone = true;
        let lk = null;

        if (!this.validphone) {
          return;
        }
        
        if(this.phoneVerificationTestActive){
          virtualPageView("/smartsearch/phone-verify");
          //call verification api here
          let verifyURL = `${process.env.VUE_APP_OA_URL}/api/phone/validate.php`;
          
          let phoneToPost = validationHelpers.getPhoneForValidation(this.formData.phone);
          const formData = new FormData();
          formData.append('phone', phoneToPost);
          axios.post(verifyURL, formData).then(res => {
            let response = res.data;
            if(response.success){
              console.log('Success')
            }
          })

          

        } else {
          //create lead here 
          lk = await this.createLead();
        }

        //udpate interaction phone
        udpateInteractionData.append('phone', this.formData.phone);
        axios.put(udpateInteractionURL, udpateInteractionData).then(res => {
          console.log(res.data)
        });

        // SAQ A/B TEST
        if (this.skipAddressQuestionsTestActive && lk) {
           window.location = `${process.env.VUE_APP_OA_URL}/diy/v2/${this.leadKey}`;
          return;
        }
      } else if (this.currentStep == 9) {
        this.checkaddress = true;
        this.isHomeOwnerError = false;
        if (this.noAddress) {
          if (this.manualStreetAddress != "" && this.suburbData != null) {
            this.addressFormData.streetaddress = this.manualStreetAddress;
            this.addressFormData.suburb = this.suburbData.suburb;
            this.addressFormData.state = this.suburbData.state;
            this.addressFormData.postcode = this.suburbData.postcode;
            this.addressFormData.postcodeid = this.suburbData.id;
            this.addressFormData.latitude = this.suburbData.latitude;
            this.addressFormData.longitude = this.suburbData.longitude;
          } else {
            return;
          }
        } else if (this.address == null) {
          return;
        }

        
        if(!this.isOwner && !this.isNotOwner) {
          this.isHomeOwnerError = true;
          return;
        }

        if(this.removeQuestionsTestActive) {
          //update additional info in the Interaction/Lead with property type
          this.addressFormData.additionalinfo = `Property Type - ${
          this.addressFormData.propertytype
        }\n${
          this.formData.be != "null"
            ? `Number of Bedrooms - ${this.formData.be}\n` +
              `Expect to sell - ${this.formData.expecttosell}\n` +
              `Reason for sale - ${this.formData.reasonforsale}\n`
            : ""
        }`;
        }


        this.addressFormData.homeowner = (this.isOwner) ? 'Yes, I own this property': 'No, I do not own this property';
        if(this.isOwner) {
          this.addressFormData.propertyowner = 1;
        }
        indigoHelpers
          .updateLead(this.leadKey, this.addressFormData)
          .then((res) => {
            if (!this.doorStepTestOne) {
              // DIY V2 PRE PROD TEST
              window.location = `${process.env.VUE_APP_OA_URL}/diy/v2/${this.leadKey}`;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (this.currentStep == -15) {
        this.formData.additionalInfo = `Message - ${this.message}`;

        this.sendmessage = true;

        if (
          this.formData.name != "" &&
          this.validemail &&
          this.validphone &&
          this.message != ""
        ) {
          this.formData.ch = 40;
          indigoHelpers
            .createInteraction(this.formData)
            .then((res) => {
              console.log(res);
              this.interactionKey = res.key;
              this.interaction = res;
              if (
                this.formData.servicetype ==
                "Rent my Property - Property Manager"
              ) {
                const leasidata = {
                  channelKey: 5,
                  subChannelKey: 5,
                  referrer_type_id: 1,
                  channel_type_id: 2,
                  utmsource: md.get("utm_source") ? md.get("utm_source") : "",
                  utmmedium: md.get("utm_medium") ? md.get("utm_medium") : "",
                  utmcampaign: md.get("utm_campaign")
                    ? md.get("utm_campaign")
                    : "",
                  name: this.formData.name,
                  phone: this.formData.phone,
                  email: this.formData.email,
                  suburb: this.formData.su,
                  property_state: this.formData.st,
                  postcode: this.formData.po,
                  message: this.message,
                };

                axios
                  .post(
                    `${process.env.VUE_APP_LEASI_API_URL}/lead`,
                    leasidata,
                    {
                      headers: {
                        "Content-Type": "application/json",
                      },
                    }
                  )
                  .then(() => {
                    this.$helpers.gtmPropperConversion();
                  })
                  .catch((e) => {
                    console.error(e);
                  });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return;
        }
      } else if (this.currentStep == -16) {
        virtualPageView("/smartsearch/general-enquiry");
      } else if (this.currentStep == -17) {
        if(!this.otpComplete){
          this.otpError = true;
          return false;
        }
        this.showIt = false;

        //create lead here
        const lk = await this.createLead();
        
        // SAQ A/B TEST
        if (this.skipAddressQuestionsTestActive && lk) {
           window.location = `${process.env.VUE_APP_OA_URL}/diy/v2/${this.leadKey}`;
          return;
        } else {
          // Go to Address question
          this.currentStep = 8;
        }
      }

      setTimeout(() => {
        this.showIt = false;
        if (this.currentStep == 8 && this.phoneVerificationTestActive && !this.otpComplete) {
            this.currentStep = -17;
        } else if(
          this.removeQuestionsTestActive && 
          this.currentStep == 1 && 
          (value == "Sell a property - Seller" || value == "Sell and buy a property - Seller and Buyer")
        ) {
            //jump to the email capture page for Question removal test
            this.currentStep = 6;
        }
        else {
          this.currentStep++;
        }
      }, 0);

      setTimeout(() => {
        this.showIt = true;
        switch (this.currentStep) {
          case 6:
            this.$nextTick(() => this.$refs.email.focus());
            break;
          case 7:
            this.$nextTick(() => this.$refs.name.focus());
            break;
          case 8:
            this.$nextTick(() => this.$refs.phone.focus());
            break;
          default:
            break;
        }
      }, 600);
    },
    backClick() {
      const queries = JSON.parse(JSON.stringify(this.$route.query));

      if (this.currentStep > 1) {
        if (this.currentStep == 4 && this.formData.propertytype == "Land") {
          this.showIt = false;
          this.currentStep = 3;
        }

        setTimeout(() => {
          this.showIt = false;
          if (this.currentStep == 6) {
            if (this.removeQuestionsTestActive) {
              //jump back to first page for Question removal test
              delete queries.st;
              this.$router.push({
                query: queries,
              });
              this.currentStep = 1;
            } else {
              this.currentStep = -22;
            }
          } else {
            this.currentStep--;
          }
        }, 0);

        setTimeout(() => {
          this.showIt = true;
        }, 600);
      } else if (
        this.currentStep == -10 ||
        this.currentStep == -5 ||
        this.currentStep == -15 ||
        this.currentStep == -14
      ) {
        delete queries.st;
        this.$router.push({
          query: queries,
        });

        setTimeout(() => {
          this.showIt = false;
          this.currentStep = 1;
        }, 0);

        setTimeout(() => {
          this.showIt = true;
        }, 600);
      } else if (this.currentStep == -22) {
        setTimeout(() => {
          this.showIt = false;
          this.currentStep = 5;
        }, 0);

        setTimeout(() => {
          this.showIt = true;
        }, 600);
      } else if (this.currentStep = -17) {
        setTimeout(() => {
          this.showIt = false;
          this.currentStep = 8;
        }, 0);

        setTimeout(() => {
          this.showIt = true;
        }, 600);
      }

      if (this.currentStep == 2) {
        delete queries.st;
        this.$router.push({
          query: queries,
        });
      }
    },
    endFirstSection(value) {
      this.formData.reasonforsale = value;
      if (!this.formData.postcodeid) {
        virtualPageView("/smartsearch/suburb");

        setTimeout(() => {
          this.showIt = false;
          this.askSuburb = true;
        }, 0);

        setTimeout(() => {
          this.showIt = true;
        }, 600);
        return;
      }

      virtualPageView("/smartsearch/loan");

      setTimeout(() => {
        this.showIt = false;
        this.currentStep = -22;
      }, 0);

      setTimeout(() => {
        this.showIt = true;
      }, 600);
    },
    otherSection(value) {
      if (value == "Property Appraisal") {
        window.location = `${process.env.VUE_APP_OA_URL}/property-reports`;
      } else if (value == "Im an Agent") {
        window.location = `${process.env.VUE_APP_OA_URL}/for-agents`;
      } else if (
        value == "Property Manager" ||
        value == "General Enquiry" ||
        value == "Agent rent" ||
        value == "Property manager2"
      ) {
        if (value == "Property manager2") {
          this.formData.servicetype = "Rent my Property - Property Manager";
        } else if (value == "Agent rent") {
          this.formData.servicetype = "Rent a Property - Looking to Rent";
        }

        this.currentStep = -16;
        this.input();
      }
    },
    setGeoGADataLayerVars(suburb, state, postcode, postcodeId) {
      // Create Data Layer Variables for
      // Adwords & Facebook Dynamic Remarketing
      this.$helpers.gaSetVariable({ suburb });
      this.$helpers.gaSetVariable({ state });
      this.$helpers.gaSetVariable({ postcode });
      this.$helpers.gaSetVariable({ postcodeId });
    },
  },
  mounted() {},
  created() {
    if (this.$route.query.st === 1 || this.$route.query.st === 2) {
      this.formData.servicetype =
        this.$route.query.st === 1
          ? "Sell a property - Seller"
          : "Sell and buy a property - Seller and Buyer";
      this.currentStep = 2;
    } else if (this.$route.query.st === 4) {
      this.currentStep = -5;
    } else if (this.$route.query.st === 5) {
      this.formData.servicetype = "other";
      this.currentStep = -10;
    }

    if (this.$route.query.st) {
      this.$helpers.gaSetVariable({ serviceType: this.formData.servicetype });
    }

    this.setGeoGADataLayerVars(
      this.$route.query.suburb,
      this.$route.query.state,
      this.$route.query.postcode,
      this.$route.query.postcodeid
    );

    if (this.formData.postcodeid) {
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/postcoderest/${this.formData.postcodeid}`
        )
        .then((response) => {
          this.postcodeData = response.data.data;
          this.formData.st = this.postcodeData.state;
          this.formData.su = this.postcodeData.suburb;
          this.formData.po = this.postcodeData.postcode;
          this.formData.latitude = this.postcodeData.latitude;
          this.formData.longitude = this.postcodeData.longitude;

          this.setGeoGADataLayerVars(
            this.postcodeData.suburb,
            this.postcodeData.state,
            this.postcodeData.postcode,
            this.postcodeData.id
          );
        })
        .catch((e) => {
          console.log(e);
        });

      axios
        .get(
          `${process.env.VUE_APP_API_URL}/postcoderest/info/${this.formData.postcodeid}`
        )
        .then((response) => {
          this.postcodeInfo = response.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    }

    setTimeout(() => {
      this.showIt = true;
      this.showTitle = true;
    }, 200);
  },
};
</script>

<style scoped lang="scss">

.main {
  display: flex;
  height: calc(100vh - 50px);
  min-height: 660px;
  
  

  @screen md {
    height: 100vh;
    min-height: 700px;
  }

  @screen lg {
    min-height: 700px;
  }

  .graphic {
    display: none;
    height: 100%;
    max-width: 35%;
    min-width: 35%;
    background-image: url("../assets/images/ss-sidebar-hero.jpg");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    margin: 0;
    z-index: 1;

    @screen md {
      display: block;
    }
  }

  .content {
    padding: 23px 24px;
    height: 100%;
    width: 100%;
    max-width: 366px;
    position: relative;

    @screen md {
      padding: 25px;
      max-width: 65%;
      min-width: 65%;
    }

    @screen xl {
      margin: 77px 0;
      padding-left: 105px;
      padding-right: 105px;
      height: auto;
    }

    .head-section {
      height: 60px;
      z-index: 1;
      position: relative;

      .oalogo {
        display: none;
        width: 150px;
        margin-left: 10px;

        @screen md {
          display: block;
        }
      }

      .oalogo-m {
        float: left;
        width: 30px;

        @screen md {
          display: none;
        }
      }
      .headphone {
        float: right;
        font-size: 16px;
        line-height: 19px;
        display: flex;
        margin-top: 0;

        @screen md {
          top: 0;
          position: absolute;
          right: 50px;
          font-size: 18px;
          margin-top: 10px;
        }

        @screen xl {
          margin-top: 8px;
        }
      }
    }

    .head-section.oth {
      height: 60px;
      z-index: 1;
      position: relative;

      .oalogo {
        display: none;
        width: 150px;
        margin-left: 10px;

        @screen md {
          display: block;
        }
      }

      .sidelogo {
        display: none;
        position: absolute;
        right: 0;
        top: 0;

        @screen md {
          display: block;
        }

        span {
          color: #494949;
          font-size: 12px;
          line-height: 15px;
        }

        .oalogo {
          display: inline-block;
          margin-left: 8px;
          width: 110px;
          margin-top: -4px;
        }
      }

      .oalogo-m {
        float: left;
        width: 133px;

        @screen md {
          display: none;
        }
      }
      .headphone {
        float: right;
        font-size: 16px;
        line-height: 19px;
        display: flex;
        margin-top: 0;

        @screen md {
          top: 0;
          position: absolute;
          right: 50px;
          font-size: 18px;
          margin-top: 10px;
        }

        @screen xl {
          margin-top: 8px;
        }
      }
    }

    .mid-text {
      // width: 550px;
      @apply ut-my-2;
    }

    .foottext {
      width: calc(100% - 42px);
      bottom: 0;
      position: absolute;
      margin-bottom: 25px;
      @screen xl {
        width: calc(100% - 150px);
      }

      @media (max-height: 800px) and (min-width: 767px) {
        bottom: -65px;
      }
    }

    .formbody {
      width: 100%;
      padding: 0 20px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      min-height: 380px;
      max-width: 550px;

      &.customFormBody {
        max-width: 550px;
      }

      &.testimonialContainer {
        // Testimonial A/B Test Classes
        @screen xl {
          max-width: 850px;
        }
      }

      @screen md {
        width: calc(100% - 25px);
        left: auto;
        transform: translateX(0%);
        top: 50%;
        transform: translateY(-50%);
        max-width: 750px;
      }

      @screen xl {
        width: calc(100% - 105px);
      }

      .text1 {
        color: #ed7824;
        line-height: 20px;
        font-size: 16px;
        position: absolute;

        @screen md {
          font-size: 20px;
          line-height: 24px;
        }
      }

      .question-header {
        font-weight: 600;
        font-size: 28px;
        letter-spacing: -0.5px;
        line-height: 36px;
        margin-bottom: 25px;
        margin-top: 28px;

        @screen md {
          margin-top: 40px;
          font-size: 36px;
          letter-spacing: -0.64px;
          line-height: 36px;
          margin-bottom: 56px;
        }
      }

      .form-header {
        font-size: 20px;
        font-weight: 600;
        letter-spacing: -0.36px;
        line-height: 28px;
        margin-bottom: 20px;
        max-width: 350px;
        margin-left: 0;
        margin-top: 28px;

        @screen md {
          margin-top: 40px;
          font-size: 22px;
          font-weight: 600;
          letter-spacing: -0.39px;
          line-height: 30px;
        }
      }

      .form-header2 {
        font-size: 20px;
        font-weight: 600;
        letter-spacing: -0.36px;
        line-height: 28px;
        margin-bottom: 20px;
        max-width: 350px;
        margin-left: 0;

        @screen md {
          margin-top: 40px;
          font-size: 22px;
          font-weight: 600;
          letter-spacing: -0.39px;
          line-height: 30px;
        }
      }

      .form-header3 {
        font-size: 20px;
        font-weight: 600;
        letter-spacing: -0.36px;
        line-height: 28px;
        margin-bottom: 10px;
        max-width: 350px;
        margin-left: 0;
        margin-top: 28px;

        @screen md {
          margin-top: 40px;
          font-size: 22px;
          font-weight: 600;
          letter-spacing: -0.39px;
          line-height: 30px;
        }
      }

      .form-header-fullwidth {
        font-size: 20px;
        font-weight: 600;
        letter-spacing: -0.36px;
        line-height: 28px;
        margin-bottom: 20px;
        margin-left: 0;
        margin-top: 50px;
        @screen md {
          margin-top: 40px;
          font-size: 22px;
          font-weight: 600;
          letter-spacing: -0.39px;
          line-height: 30px;
        }
      }

      .q-section {
        .radio-row {
          display: flex;
          width: 100%;
          margin-bottom: 21px;
          justify-content: space-between;

          @screen md {
            justify-content: space-evenly;
          }

          @screen lg {
            width: 50%;
            margin-bottom: 0;
          }
        }
        .row {
          @screen lg {
            display: flex;
          }
          .option-field {
            width: 100%;
            margin-right: 20px;
            margin-top: 12px;
          }
        }
        .review-block {
          width: 260px;
          position: absolute;
          left: 450px;
          top: 45px;
          background-color: #f5f5f5;
          border-radius: 8px;
          padding: 24px;
          display: none;

          @media (max-width: 1400px) {
            left: 500px;
          }

          @media (max-width: 1200px) {
            display: none;
          }

          .stars {
            margin-bottom: 10px;
            div {
              display: inline-block;
              margin-right: 3px;
            }
          }

          .reviewtext {
            color: #6d6c6b;
            font-size: 16px;
            line-height: 28px;
          }
          .reviewname {
            margin-top: 5px;
            color: #6d6c6b;
            font-size: 16px;
            font-weight: bold;
            line-height: 28px;
          }
        }
      }
    }
  }
  .dscontent {
    @media (max-width: 750px) {
      height: 125%;
    }
  }
  .smalltxt {
    color: #6d6c6b;
    font-size: 14px;
    line-height: 20px;
    margin-left: 0;

    a {
      text-decoration: underline;

      &:hover {
        color: #00ab64;
      }
    }
  }
  .back-btn {
    margin-left: 0;
    width: fit-content;
    cursor: pointer;
    padding-bottom: 5px;

    &:after {
      @apply ut-text-Gnew;

      content: " Back";
    }

    div {
      display: inline-block;
      vertical-align: text-bottom;
    }
  }
  .back-btn.oth {
    &:after {
      @apply ut-text-blueOTH;
    }
  }
  .inputbox {
    max-width: 350px;
    margin-left: 0;
  }
  .btn {
    max-width: 350px;
    margin-left: 0;
    div {
      float: right;
      margin-top: 3px;
    }
  }

  .suburbsearch1 {
    max-width: 500px;
    margin-left: 0;
  }
  .empty-btn {
    padding: 11px 20px;
  }

// Testimonial A/B Test Classes
// hide review on smaller screens as it doesn't have enough space to fit in the review
.testimonial-name {
  margin-top: 3rem;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 2rem;
  max-width: 350px;
  margin-left: 0;
  display: none;

  @media (min-height: 844px) {
    display: block;
  }

  @screen md {
    border-bottom: 0px;
    margin-top: 5rem;
  }

  @screen lg {
    margin-top: 0;
  }

  @screen xl {
    position: absolute;
    top: 20px;
    left: 400px;
    padding-right: 20px;
  }

  @media screen and (min-width: 1400px) {
    left: 500px;
  }
}

.testimonial-email {
  margin-top: 8rem;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 2rem;
  max-width: 350px;
  margin-left: 0;
  display: none;

  @media (min-height: 844px) {
    display: block;
  }

  @screen md {
    border-bottom: 0px;
  }

  @screen lg {
    margin-top: 0;
  }

  @screen xl {
    position: absolute;
    top: 20px;
    left: 400px;
    padding-right: 20px;
  }

  @media screen and (min-width: 1400px) {
    left: 500px;
  }
}

.testimonial-phone {
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 2rem;
  max-width: 350px;
  margin-left: 0;
  display: none;

  @media (min-height: 844px) {
    display: block;
  }

  @screen md {
    margin-top: 5rem;
    border-bottom: 0px;
  }

  @screen lg {
    margin-top: 0px;
    padding-bottom: 0px;
  }

  @screen xl {
    position: absolute;
    top: 20px;
    left: 400px;
    margin-top: 0px;
    padding-right: 20px;
  }

  @media screen and (min-width: 1400px) {
    left: 500px;
  }
}
}


</style>